export default "__VITE_ASSET__CUW6K9OV__"